import { useInitialUiEngineProps, useSelectorsTile } from 'app/area/case-report/case-listing/hooks';
import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { HeaderVisibilityConfiguration } from 'app/components';
import { RenderMode } from 'app/types-shared';
import * as React from 'react';
import { CaseListingTile } from './components/case-listing-tile';

export interface CaseListingTileContainerProps {
  caseNumber: number;
  entityId: number;
  entityStoreKey: string;
  headerVisibilityConfiguration: HeaderVisibilityConfiguration;
  renderMode: RenderMode;
  primaryActionComponentFactory?: PrimaryActionComponentFactory;
}

export const CaseListingTileContainer = ({
  caseNumber,
  entityId,
  entityStoreKey,
  primaryActionComponentFactory, 
  headerVisibilityConfiguration, 
  renderMode
}: CaseListingTileContainerProps) => {

  const {
    item,
    uiDefinition,
    permissions
  } = useSelectorsTile(caseNumber, entityId, entityStoreKey);

  const initialUiEngineProps = useInitialUiEngineProps(
    renderMode, 
    uiDefinition?.definition, 
    entityId,
    entityStoreKey,
    caseNumber,
    headerVisibilityConfiguration
  );

  return (!item?.deleted && initialUiEngineProps ? <CaseListingTile
    caseNumber={caseNumber}
    primaryActionComponentFactory={primaryActionComponentFactory}
    permissions={permissions}
    initialUiEngineProps={initialUiEngineProps}
  /> : null);
};
